<template>
    <div class="row reports-performer-summary">
        <div class="col">
            <div class="row">
                <div class="col">
                    <table-resume
                        :title="title"
                        :route="route"
                        :externalFilters="filters"
                        :extraQueryParams="extraQueryParams"
                        :autoUpdateExternalFilter="autoUpdateExternalFilter"
                        :autoUpdateFilter="true"
                        :showTitleData="false"
                        titleClass="subtitle"
                        :settings="settings"
                        :columns="columns"
                        :loadingMsg="loadingMsg"
                        :notFoundMsg="notFoundMsg"
                        :orderByTemplate="orderByTemplate"
                        :confirmExportData="false"
                        :allowExportData="allowExportData"
                        :titleExportData="titleExportData"
                        :confirmMsgExportData="confirmMsgExportData"
                        :errorMsgExportData="errorMsgExportData"
                        :showPagination="false"
                        tableWrapperClass="bg-lilac-light"
                        tableClass="table-responsive-sm"
                        :funcExportData="onExport"
                    >
                        <template v-slot:body="{row, index}">
                            <td>{{ row.name }}</td>
                            <td v-for="(column, idx) in columns" v-if="column.id">
                                {{ getValueFromItem(row.states, column) }}
                            </td>
                        </template>
                    </table-resume>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {HasLoadingState, HasReport} from './mixins/index';

    export default {
        name: 'reportPerformerSummary',
        mixins: [
            HasLoadingState,
            HasReport
        ],
        components: {
            TableResume: () => import(/* webpackChunkName: "data-table" */ '@/app/shared/components/tables/DataTable'),
        },
        props: {
            autoUpdateExternalFilter : {
                type: Boolean,
                default: false
            },
            states: {
                type: Array,
                required: true,
            },
            columns: {
                type: Array,
                default: () => {
                    return [{
                        label: 'Executante',
                    }]
                },
            }
        },
        data() {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    @import "@styles/_mixins.scss";
    @import "@styles/_theme.scss";
    .reports-performer-summary {
        td:not(:first-child) {
            white-space: nowrap;
        }
    }
</style>